import { render, staticRenderFns } from "./WasteRuleMonitor.vue?vue&type=template&id=6e9c6796&scoped=true&"
import script from "./WasteRuleMonitor.vue?vue&type=script&lang=js&"
export * from "./WasteRuleMonitor.vue?vue&type=script&lang=js&"
import style0 from "./WasteRuleMonitor.vue?vue&type=style&index=0&id=6e9c6796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c6796",
  null
  
)

export default component.exports